module.exports = __webpack_public_path__ + "img/call.8bd22462.svg";